import type { Listing } from '@thevillages/schemas';

type recordValue = Record<string, unknown>;

/**
 * Properly formats the provided object as a listing.
 *
 * @param {Listing} data The improperly formatted object.
 * @return {Listing} The properly formatted object.
 */
export function Format(data: Listing): Listing {
  const _date = data.date;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This is a valid check for null or undefined values.
  if (_date) {
    data.date = toDate(_date);
  }

  // Convert date strings to Date objects.
  formatOpenHours(data.openToday);
  formatOpenHours(data.openTomorrow);

  return data;
}

function formatOpenHours(value: unknown): void {
  if (!isRecord(value)) {
    return;
  }

  const _start = value.start;
  if (_start) {
    value.start = toDate(_start);
  }

  const _end = value.end;
  if (_end) {
    value.end = toDate(_end);
  }
}

function isRecord(value: unknown): value is recordValue {
  return typeof value === 'object' && value !== null;
}

function toDate(value: unknown): Date {
  return value instanceof Date ? value : new Date(String(value));
}
